import { Props } from './Props';
import { Renderer } from './Renderer';

export class Template {
    private readonly _renderer: Renderer;

    public constructor(template: string) {
        this._renderer = Template.createRenderer(template);
    }

    public render(props: Props): string {
        return this._renderer(props);
    }

    private static createRenderer(template: string): Renderer {
        /**
         * Replace tabs and new lines characters with a space
         */
        let html = template.replace(/[\r\t\n]/g, ' ');

        /**
         * Replace the print variable opening brackets `{{` for `',`
         */
        html = html.replace(/\{\{/g, "',");

        /**
         * Replace the print variable closing brackets `}}` for `,'`
         */
        html = html.replace(/\}\}/g, ",'");

        /**
         * Replace the statement opening bracket `{%` for `');`
         */
        html = html.replace(/\{%/g, "');");

        /**
         * Replace the statement closing bracket `%}` for `lines.push('`
         */
        html = html.replace(/%\}/g, "lines.push('");

        /**
         * The string:
         * `<p>{% if greet == true { %}Hello {% } %}{{ name }}</p>`
         * will result in:
         * `<p>'); if greet == true { lines.push('Hello '); } lines.push('', name ,'</p>`
         *
         * This will result below in:
         * lines.push('<p>'); if greet == true { lines.push('Hello '); } lines.push('', name ,'</p>');
         */
        return new Function(
            '_context',
            `var lines = [];
             with (_context) {
                lines.push('${html}');
             }
             return lines.join('');`,
        ) as Renderer;
    }
}
